import config from '../config/app'
import axios from 'axios'

const PATH = '/membership'
export default {
  create (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH, fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  update (id, fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/' + id, fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getById (id, additional) {
    return new Promise((resolve, reject) => {
      this.get({id: id}, additional).then((response) => {
        resolve(response.data[0])
      }, (error) => {
        reject(error)
      })
    })
  },
  get (params, additional) {
    params = typeof params === 'object' && params !== null ? params : {}
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + PATH + '?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  cancelSubscription (data = null) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/cancel-subscription', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  createCouponcode (data = null) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/create-coupon', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  retriveSubscription (data = null) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/retrive-subscription', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  requestForFreeMonthSubscription (data = {}) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/freemonth-subscription', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  sendShareSegment (membershipData) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/send-details', membershipData).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  payStripe (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/process-payment', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({message: error.response.data.error.message, code: error.response.data.error.code})
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/membership.js